module.exports = __webpack_public_path__ + "img/edc-danamon.cd26e47d.png";